import { render, staticRenderFns } from "./AppraisalTabs.vue?vue&type=template&id=628188e3"
import script from "./AppraisalTabs.vue?vue&type=script&lang=ts"
export * from "./AppraisalTabs.vue?vue&type=script&lang=ts"
import style0 from "./AppraisalTabs.vue?vue&type=style&index=0&id=628188e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports